
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _91id_93Rsphra07USDgI_451CWSq163BGG6AvhZdwKauwU1kctf0Meta } from "/opt/buildhome/repo/pages/order/[id].vue?macro=true";
import { default as all_45countries0qoNL_uVq9joCLEiMMSPADpMWSfUTget2ObAUGrTQcEMeta } from "/opt/buildhome/repo/pages/all-countries.vue?macro=true";
import { default as _91country_93_45esim_qm8lymYv4nMY7RckMr0dcnASXT3qUINw6bIf3I3h4EMeta } from "/opt/buildhome/repo/pages/[country]-esim.vue?macro=true";
import { default as after_45checkoutTWyTvbygxJxh3EDLI7hQ80JRZkPpXOIa7w2ABhsxTt8Meta } from "/opt/buildhome/repo/pages/after-checkout.vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as terms_45and_45conditionsaRHDHJ7OmbsuXtN1K_45pcdrdkRBetipFmbwCNKKUEzBUMeta } from "/opt/buildhome/repo/pages/terms-and-conditions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "order-id",
    path: "/order/:id()",
    component: () => import("/opt/buildhome/repo/pages/order/[id].vue")
  },
  {
    name: "all-countries",
    path: "/all-countries",
    component: () => import("/opt/buildhome/repo/pages/all-countries.vue")
  },
  {
    name: "country-esim",
    path: "/:country()-esim",
    component: () => import("/opt/buildhome/repo/pages/[country]-esim.vue")
  },
  {
    name: "after-checkout",
    path: "/after-checkout",
    component: () => import("/opt/buildhome/repo/pages/after-checkout.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/opt/buildhome/repo/pages/terms-and-conditions.vue")
  }
]